<template>
  <div class="pc-bread">
    <h2>{{ title }}</h2>
    <el-breadcrumb separator="/" class="pc-breadcrumb">
      <el-breadcrumb-item v-for="item in data" :key="item.name">
        <router-link :to="item.link">
          {{ item.name }}
        </router-link>
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["data", "title"],
  created() {},
  methods: {},
};
</script>
<style  scoped lang="scss">
.pc-bread {
  display: flex;
  padding-bottom: 20px;
  border-bottom: 1px solid #c0c0c0;
  > h2 {
    font-size: 20px;
    padding: 35px 40px 0 0;
    align-self: flex-end;
  }
  .pc-breadcrumb {
    margin-top: 45px;
    /deep/ .el-breadcrumb__item {
      .el-breadcrumb__inner {
        a {
          font-size: 15px;
          font-weight: 400;
          color: #434343;
        }
      }
      .el-breadcrumb__separator {
        margin: 0 5px;
      }
      .router-link-active {
        color: $lightenYellow !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/componentSet/BreadCrumb.vue